'use strict';

function ctrl($locationProvider) {
    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false
    }); // new url config (no #! prepended)
}

ctrl.$inject = ['$locationProvider'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/system/routes/html5urls.js
 **/